import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import Card from "../HOME/Card";
import Cards from "../HOME/Card";

const Brands = () => {
  const [isActive,setIsActive]=useState(0)
  const handleActive=(num:any)=>{
    setIsActive(num)
  }
  return (
    <>
      <section className="pb-4" style={{ paddingTop: "6rem" }}>
        <Container>
          <div>
            <p className="title-para">Home - Samsung</p>
            <h2 className="title-navhead">Brand</h2>
          </div>
        </Container>
        <div className="py-4">
          <img src="/assets/Group 679.png" className="img-fluid" />
        </div>
        <div className="pt-3">
          <h2 className="head-txt-1">
            <span>Bestselling</span> Of Samsung
          </h2>
          <div className="pt-3">
            <Container>
            <div className="row py-3">

              {/* <Card /> */}
              </div>
            </Container>
          </div>
        </div>
      </section>
      <section className="py-4">
        <Container>
        <h2 className="head-txt-1">
            <span>Shop</span> By Products
          </h2>
            {/* <div className="col-lg-6 col-md-8 col-sm-10 col-10 d-flex justify-content-between align-items-center">
              <div className="text-center" style={{cursor:"pointer"}} onClick={()=>handleActive(0)}>
                <img src="/assets/phone.png" className="img-fluid img-1"/>
                <p className={`pt-2 ${isActive===0?"prod-selectActive":"prod-select"}`}>Smart Phone</p>
              </div>
              <div className="text-center" style={{cursor:"pointer"}} onClick={()=>handleActive(1)}>
                <img src="/assets/watch.png" className="img-fluid img-2"/>
                <p className={`pt-2 ${isActive===1?"prod-selectActive":"prod-select"}`}>Watch</p>
              </div>
              <div className="text-center" style={{cursor:"pointer"}} onClick={()=>handleActive(2)}>
                <img src="/assets/earphone.png" className="img-fluid img-3"/>
                <p className={`pt-2 ${isActive===2?"prod-selectActive":"prod-select"}`}>Air Pods</p>
              </div>
            </div> */}
              <div className="d-flex justify-content-end align-items-center">
              <button className="filterbrand-btn">
                All Filter &nbsp;&nbsp;&nbsp;
                <i className="fi fi-rr-bars-filter"></i>
              </button>
            </div>
          <div>
          <div className="row py-3">

            {/* <Cards/> */}
            </div>
            <div className="text-center py-2"><Button className="buy-now">View More</Button></div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Brands;
